import React from "react";
import Wrapper from "../components/wrapper/index";
import Projects from "../components/portfolio/index";

function Portfolio() {
  return (
    <Wrapper>
      <Projects />
    </Wrapper>
  );
}

export default Portfolio;